module.exports = __webpack_public_path__ + "img/no_data_place_holder.19b8808c.svg";